<template>
    <div>
        <htmlHeader :top_index="4" :menuCode="false" :crumbsShow="false" />
        <div class="swiper_box">
            <a-carousel :autoplay="true" style="width: 100%; height: 400px">
                <div v-for="(item, index) in news_top_img" :key="index" :to="item.url" class="banner-container">
                    <div class="banner-info">
                        <div>{{ item.mainTitle }}</div>
                        <div>{{ item.subtitle }}</div>
                    </div>
                    <img :src="item.picture" style="width: 100%; height: 400px" alt="" />
                </div>
            </a-carousel>
        </div>
        <div style="width: 1200px; margin: auto; padding-bottom: 10%; overflow: hidden; position: relative">
            <div style="overflow: hidden; margin-top: 2%">
                <a-input-search v-model="search" placeholder="请输入要搜索的文章标题或关键字" style="width: 400px; float: left" @search="onSearch" />
            </div>
            <div style="overflow: hidden">
                <div
                    @click="chang_firstSort(index, item)"
                    :class="['news_type1', firstSort_index === index ? 'yiji_active' : '', index === 0 ? 'diyige' : '']"
                    v-for="(item, index) in firstSort"
                    :Key="index"
                >{{ item.sortName }}</div>
            </div>
            <div class="box1">
                <div style="overflow: hidden; margin: 10px auto">
                    <div
                        @click="chang_secondSort(index, item)"
                        :class="['box3', secondSort_index === index ? 'erji_active' : '']"
                        v-for="(item, index) in secondSort"
                        :Key="index"
                    >{{ item.sortName }}</div>
                </div>
            </div>
            <div>
                <div class="box5" v-for="(item, index) in news_list" @click="to_news_details(item.uuid, index)" :Key="index">
                    <div style="overflow: hidden">
                        <img :src="'/api/file/preview/' + item.articleCover" class="news_item_img" alt="" />
                        <div style="float: left; overflow: hidden;width: 593px;">
                            <div class="news_time">
                                <div class="new_item_time1">{{ item.yue }}</div>
                                <div class="new_item_time2">-{{ item.nian }}-</div>
                            </div>
                            <div class="news_item_title">{{ item.articleTitle }}</div>
                            <div class="new_item_txt">{{ item.articleSummary }}</div>
                            <div class="news_item_details_link">[查看详情]</div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="text-align: center; position: absolute; bottom: 2%; left: 40%">
                <a-pagination show-quick-jumper :default-current="2" :total="totalPages * 10" @change="fanye" />
            </div>
        </div>
        <foot />
    </div>
</template>

<script>
import axios from 'axios';
import userLeft from '../public/user_left';
import htmlHeader from '../public/head';
import foot from '../public/foot';
export default {
    name: 'News',
    components: {
        userLeft,
        htmlHeader,
        foot
    },
    data() {
        return {
            activeRoot: null,
            activeSub: null,
            totalPages: 1, //总页数
            firstSort: [], //一级分类
            secondSort: [], //二级分类
            firstSort_index: 0, //一级分类索引
            secondSort_index: null, //二级分类索引
            page: 0, //页码
            search: '', //搜索文字
            news_list: [], //新闻列表
            news_top_img: [] //新闻顶部图片
        };
    },
    methods: {
        // 获取新闻顶部图片
        get_news_top_img() {
            this.api.get_news_top_img().then(res => {

                const data = JSON.parse(res.data.description)
                data.forEach(i => {
                  i.picture = `/api/file/preview/${i.picture}`
                  i.url = `/news_details?uuid=${i.uuid}`
                })
                this.news_top_img = data
            });
        },
        // 去新闻详情
        to_news_details(e, index) {
            this.$router.push('/news_details?uuid=' + e);
        },
        // 切换一级分类
        chang_firstSort(index, item) {
            this.firstSort_index = index;
            this.secondSort_index = null
            this.get_secondSort();
            this.get_news_list();
        },
        // 切换二级分类
        chang_secondSort(index, item) {
            this.activeSub = item;
            this.secondSort_index = index;
            this.get_news_list();
        },

        // 翻页
        fanye(e) {
            this.page = e;
            this.get_news_list();
        },
        // 搜索
        onSearch(e) {
            this.search = e;
            this.get_news_list();
        },
        // 获取新闻列表
        get_news_list() {
            let firstSort = ''
            let secondSort = []
            if (this.firstSort_index > 0) {
                firstSort = this.firstSort[this.firstSort_index].sortName
            }
            if (this.secondSort_index !== null) {
                secondSort.push(this.secondSort[this.secondSort_index].sortName)
            }

            let obj = {
                page: this.page,
                size: 6,
                search: this.search,
                firstSort,
                secondSort,
            };
            this.api.get_news_list(obj).then(res => {
                if (res.ok) {
                    this.news_list = res.data.content;
                    this.totalPages = res.data.totalPages;
                    // 分割日期
                    this.news_list.forEach(element => {
                        element.nian = element.updatedAt.substr(0, 4);
                        element.yue = element.updatedAt.substr(5, 6);
                        if (element.articleSummary.length > 80) {
                            element.articleSummary = element.articleSummary.slice(0, 80) + '……'
                        }
                    });
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        // 新闻一级分类
        get_firstSort() {
            const that = this;
            this.api.newsClasstList().then(res => {
                if (!res.ok) {
                    this.$message.error(res.message);
                    return false;
                }
                let { data = [] } = res;
                let secondSort = [];
                data.forEach(item => {
                    item.secondSort.map(list => {
                        list.firstSortItem = item;
                    });
                    secondSort = [...secondSort, ...item.secondSort];
                });
                this.firstSort = [
                    {
                        sortName: '全部分类',
                        secondSort
                    },
                    ...data
                ];
               this.get_secondSort()
            });
        },
        // 新闻二级分类
        get_secondSort() {
            this.secondSort = this.firstSort[this.firstSort_index].secondSort;
        }
    },
    created() {
        this.get_firstSort();
        this.get_news_list();
        this.get_news_top_img();
    }
};
</script>

<style scoped>
div > .box5:last-child {border-bottom: none;}
.news_time {
    position: absolute;
    right: 0;
    margin-top: 30px;
}
.banner-container {position: relative;}
.banner-info {
    position: absolute;
    width: 100%;
    text-align: center;
    color: white;
}
.banner-info > div:first-child {margin: 120px 0 30px;font-size: 40px;}
.banner-info > div:last-child {font-size: 28px;}

.fengexian {
    width: 80%;
    float: right;
    height: 1px;
    border: 1px dashed #eeeeee;
    margin-top: 2%;
}
.news_item_details_link {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #2c9a34;
}
.new_item_time1 {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #727272;
    text-align: center;
}

.new_item_time2 {
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #646262;
    text-align: center;
}
.new_item_txt {
    margin-bottom: 24px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    width: 593px;
    height: 40px;
    line-height: 20px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.news_item_title {
    margin-bottom: 16px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 20px;
    color: #444444;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis
}
.box5 {
    margin-left: 240px;
    padding: 20px 0;
    overflow: hidden;
    color: #000;
    cursor: pointer;
    border-bottom: 1px dashed #eee;
    object-fit: cover;
}
.news_item_img {
    margin-right: 22px;
    padding: 7px;
    width: 225px;
    height: 135px;
    float: left;
    border: 1px solid #EDE9E9;
}
.news_type1 {
    height: 40px;
    text-align: center;
    line-height: 40px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #343434;
    float: left;
    margin-left: 2%;
    padding: 0 2%;
    margin-top: 2%;
    cursor: pointer;
}
.swiper_box {
    width: 100%;
    height: 400px;
    overflow: hidden;
}
.box3 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: Regular;
    color: #666666;
    margin-top: 6%;
    padding-left: 20px;
    cursor: pointer;
}

.box4 {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
}

.box1 {
    width: 220px;
    min-height: 487px;
    border: 1px solid #ede9e9;
    float: left;
    margin-top: 20px;
}

.box2 {
    width: 100%;
    height: 45px;
    background: #f2f2f2;
}
.erji_active {
    border-left: 2px solid #2b9a34;
    color: #2b9a34;
}
.yiji_active {
    border: 1px solid #2c9a34;
    color: #2b9a34;
}
.diyige {
    margin-left: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/news.vue